
import { getTextures, getObjects } from "./Base.js"

const grassH = 85
const grassS = 28
const grassL = 1.1

export const defaultProperties = {
	grassH: grassH,
	grassS: grassS,
	grassL: grassL,
	greenLightness: 56 * grassL,
	semiGreenLightness: 50 * grassL,
	teeLightness: 45 * grassL,
	fairwayLightness: 43 * grassL,
	backgroundLightness: 37 * grassL,
	roughLightness: 33 * grassL,
	grassBunkerLightness: 31 * grassL,
	contrastRoughness: 0.9,
	grassSizeScale: 0.8,
	foliageLightness: 1.1,
	foliageHue: 0.95,
	images: ['diffuse']
}
export const Textures = getTextures(defaultProperties)
export const Objects = getObjects(defaultProperties)